<h2 class="text-center">Kaizen Details</h2>
<mat-stepper class="example-stepper">
  <mat-step label="Contact Information and Kaizen Location">
    <ng-template matStepContent>
      <br>
        <h3>Kaizen Num : K{{KaizenCombined.kaizenNumber}}</h3>
        <div class="card m-6">
          <h5 class="card-header">Contact Information</h5>
          <div class="card-body">
            <div class="row">
              <div class="col">
                <div class="form-group row">
                  <label for="kaizenCreator" class="col-sm-6 col-form-label">Kaizen Creator:</label>
                  <div class="col-sm-6">
                    <label for="kaizenCreator" class=" col-form-label"><b>{{KaizenCombined.kaizenCreator}}</b></label>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="kaizenLeader" class="col-sm-6 col-form-label">Kaizen Leader:</label>
                  <div class="col-sm-6">
                    <label for="kaizenCreator" class="col-form-label"><b>{{KaizenCombined.kaizenLeader}}</b></label>
                  </div>
                </div>
              </div>
              <div class="col-md-auto">
              </div>
              <div class="col col-lg-6">
                <table class="table table-condensed">
                  <thead>
                    <tr>
                      <td>Supporting Member List</td>
                    </tr>
                  </thead>
                  <tbody>
                    @for (member of supportingMembers; track member; let i = $index) {
                      <tr>
                        <td>
                          <label for="kaizenCreator" class="col-sm-6 col-form-label"><b>{{member}}</b></label>
                          <td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <br>
              <div class="card">
                <h5 class="card-header">Kaizen Location</h5>
                <div class="card-body">
                  <div class="form-group row">
                    <label for="NAMC" class="col-sm-3 col-form-label">NAMC:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.companyName}}</b></label>
                    </div>
                    <label for="NAMC" class="col-sm-3 col-form-label">Supporting NAMC:</label>
                    <div class="col-sm-3">
                      <label class="col-form-label"><b>{{KaizenCombined.supportingNAMC}}</b></label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="line" class="col-sm-3 col-form-label">Line:</label>
                    <div class="col-sm-3">
                      <label class="col-form-label"><b>{{KaizenCombined.lineName}}</b></label>
                    </div>
                    <label for="line" class="col-sm-3 col-form-label">Supporting Line:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.supportingLine}}</b></label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="shopId" class="col-sm-3 col-form-label">Shop:</label>
                    <div class="col-sm-3">
                      <label class="col-form-label"><b>{{KaizenCombined.namCimpacted}}</b></label>
                    </div>
                    <label for="supportingShopId" class="col-sm-3 col-form-label">Supporting Shop:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.supportingShop}}</b></label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="costCenter" class="col-sm-3 col-form-label">Cost Center:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.costCenterName}}</b></label>
                    </div>
                    <label for="supportCostCenter" class="col-sm-3 col-form-label">Supporting Cost Center:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.supportingCostCenter}}</b></label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="model" class="col-sm-3 col-form-label">Model:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.modelName}}</b></label>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="costCenter" class="col-sm-3 col-form-label">Calculate Savings Impact:</label>
                    <div class="col-sm-3">
                      <label class=" col-form-label"><b>{{KaizenCombined.calculateSavingsImpact}}</b></label>
                    </div>
                  </div>
                </div>
              </div>
              <br>
                <div class="card">
                  <h5 class="card-header">Yokoten</h5>
                  <div class="card-body">
                    <div class="form-group row">
                      <label for="yokotenFromOtherShop" class="col-sm-6 col-form-label">Is this yokoten from another shop or
                      plant?</label>
                      <div class="col-sm-6">
                        <label class=" col-form-label"><b>{{KaizenCombined.isYokoyenFromAnotherShop ? "YES" : "NO"}}</b></label>
                      </div>
                    </div>
                    <div>
                      <div class="form-group row">
                        <label for="haveBpaksID" class="col-sm-6 col-form-label">Does the original kaizen have a BPAKS ID?</label>
                        <div class="col-sm-6">
                          <label class=" col-form-label"><b>{{KaizenCombined.haveBpaksID ? "YES" : "NO"}}</b></label>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="KaizenSourceIdentifier" class="col-sm-6 col-form-label">BPAKS Kaizen ID:</label>
                        <div class="col-sm-6">
                          <label class=" col-form-label"><b>{{KaizenCombined.kaizenSourceIdentifier}}</b></label>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="kaizenSourceId" class="col-sm-6 col-form-label">If yes please specify the source:</label>
                        <div class="col-sm-6">
                          <label class=" col-form-label"><b>{{KaizenCombined.kaizenSource}}</b></label>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="kaizenSourceDescription" class="col-sm-6 col-form-label">Identifier number or
                        description:</label>
                        <div class="col-sm-6">
                          <label class=" col-form-label"><b>{{KaizenCombined.kaizenSourceDescription}}</b></label>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="additionalKaizenSourceDescription" class="col-sm-6 col-form-label">Additional description or
                        comments:</label>
                        <div class="col-sm-6">
                          <label class=" col-form-label"><b>{{KaizenCombined.additionalKaizenSourceDescription}}</b></label>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="yokotenToOtherShop" class="col-sm-6 col-form-label">Can this be yokotened to another
                      shop?</label>
                      <div class="col-sm-6">
                        <label class=" col-form-label"><b>{{KaizenCombined.applicableForOtherShopOrPlants ? "YES" :
                        "NO"}}</b></label>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="applicableForSpecificShop" class="col-sm-6 col-form-label">Applicable for specific shop?</label>
                      <div class="col-sm-6">
                        <label class=" col-form-label"><b>{{KaizenCombined.applicableToSpecificShops ? "YES" : "NO"}}</b></label>
                      </div>
                      <label for="applicableForOtherShop" class="col-sm-6 col-form-label">Applicable across other shops?</label>
                      <div class="col-sm-6">
                        <label class=" col-form-label"><b>{{KaizenCombined.applicableToAllShops ? "YES" : "NO"}}</b></label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="email">Please provide any additional tags/keywords that can be used for other users to search
                      this kaizen:</label>
                      <div class="input-group">
                        <div class="col-sm-2">
                          <label class=" col-form-label"><b>{{KaizenCombined.keyword1}}</b></label>
                        </div>
                        <span class="input-group-addon">&nbsp;</span>
                        <div class="col-sm-2">
                          <label class=" col-form-label"><b>{{KaizenCombined.keyword2}}</b></label>
                        </div>
                        <span class="input-group-addon">&nbsp;</span>
                        <div class="col-sm-2">
                          <label class=" col-form-label"><b>{{KaizenCombined.keyword3}}</b></label>
                        </div>
                        <span class="input-group-addon">&nbsp;</span>
                        <div class="col-sm-2">
                          <label class=" col-form-label"><b>{{KaizenCombined.keyword4}}</b></label>
                        </div>
                        <span class="input-group-addon">&nbsp;</span>
                        <div class="col-sm-2">
                          <label class=" col-form-label"><b>{{KaizenCombined.keyword5}}</b></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                  <div class="card">
                    <h5 class="card-header">Ringi</h5>
                    <div class="card-body">
                      <div class="form-group col-sm-12">
                        <div class="form-group row">

                          <span>
                            <label class="col-sm-6 col-form-label">Will a ringi be required for implementation? :</label>
                            @if (KaizenCombined.ringiNumber != '') {
                              <label class="col-sm-4 "><b>&nbsp;&nbsp;YES</b></label>
                            }
                            @if (KaizenCombined.ringiNumber == '') {
                              <label class="col-sm-4 "><b>&nbsp;&nbsp;NO</b></label>
                            }
                          </span>
                          @if (KaizenCombined.ringiNumber != '') {
                            <span>
                              <label class="col-sm-6 col-form-label">Project/ringi id :</label>
                              <label class="col-sm-4 "><b>&nbsp;&nbsp;{{KaizenCombined.ringiNumber}}</b></label>
                              <label class="col-sm-6 col-form-label">Investment amount&nbsp;: </label>
                              <label class="col-sm-4"><b>&nbsp;&nbsp;{{KaizenCombined.investmentAmount | currency}}&nbsp;{{createKaizen.currencyCode}}</b></label>
                            </span>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <br>
                    <div class="card">
                      <h5 class="card-header">Kaizen Description</h5>
                      <div class="card-body">
                        <div class="form-group row">
                          <span>
                            <label for="kaizenTitle" class="col-sm-6 col-form-label">Kaizen Name:</label>
                            <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.title}}</b></label>
                          </span>

                        </div>
                        <div class="form-group row">

                          <label for="kaizenDescription" class="col-sm-6 col-form-label">Brief Description (used for Obeya
                          Report) :</label>
                          <div class="col-sm-6 pull-1">
                            <label><b>&nbsp;&nbsp;{{KaizenCombined.description}}</b></label>
                          </div>


                        </div>
                        <div class="form-group row">
                          <span>
                            <label for="kaizenAdditionalComments" class="col-sm-6 col-form-label">Additional Comments :</label>
                            <label class="col-sm-6"><b>&nbsp;&nbsp;{{KaizenCombined.additionalComments}}</b></label>
                          </span>
                        </div>

                        <label class="kaizen-attachment-label">Kaizen attachments</label>
                        <table class="table table-condensed">
                          <thead>
                            <tr>
                              <th scope="col">Id</th>
                              <th scope="col">File Name</th>
                              <th scope="col">View</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (attachment of kaizenAttachments; track attachment; let i = $index) {
                              <tr>
                                <ng-container>
                                  <td>{{i+1}}</td>
                                  <td>{{attachment.attachmentName}}</td>
                                  <td><mat-icon class="link-primary"
                                  (click)="downloadAttachment(attachment.attachmentName, attachment.kaizenID)">pageview</mat-icon>
                                </td>
                              </ng-container>
                            </tr>
                          }
                        </tbody>
                      </table>

                    </div>
                  </div>

                  <div class="card">
                    <h5 class="card-header">Rank Information</h5>
                    <div class="card-body">

                      <div class="form-group row">
                        <span>
                          <label for="ProjectType" class="col-sm-6 col-form-label">Project Type:</label>
                          <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.projectType}}</b></label>
                        </span>
                      </div>

                      <div class="form-group row">
                        <span>
                          <label for="InvestmentType" class="col-sm-6 col-form-label">Investment Type:</label>
                          <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.investmentType}}</b></label>
                        </span>
                      </div>

                      <div class="form-group row">
                        <span>
                          <label for="Rank" class="col-sm-6 col-form-label">Rank:</label>
                          <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.rank}}</b></label>
                        </span>
                      </div>

                      <div class="form-group row">
                        <span>
                          <label for="RankDecisionTiming" class="col-sm-6 col-form-label">Rank Decision Timing:</label>
                          @if (this.KaizenCombined.rankDecisionTiming !== undefined) {
                            <label
                              class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.rankDecisionTimingString}}</b></label>
                            }
                          </span>
                        </div>

                        <div class="form-group row">
                          <span>
                            <label for="RankDifficulty" class="col-sm-6 col-form-label">Difficulty Ranking:</label>
                            <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.rankDifficulty}}</b></label>
                          </span>
                        </div>

                        <div class="form-group row">
                          <span>
                            <label for="RankChangeDescription" class="col-sm-6 col-form-label">Rank Change Description:</label>
                            <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.rankChangeDescription}}</b></label>
                          </span>
                        </div>

                        <div class="form-group row">
                          <span>
                            <label for="MilestoneImplemented" class="col-sm-6 col-form-label">Milestone Implemented:</label>
                            <label class="col-sm-5"><b>&nbsp;&nbsp;{{KaizenCombined.milestoneImplemented}}</b></label>
                          </span>
                        </div>

                      </div>
                    </div>

                    <div class="buttonrow">
                      <br>
                        <button mat-flat-button type="button" color="primary" (click)="cancel()">Cancel</button>
                        <button mat-flat-button matStepperNext type="submit" color="primary">Next : Cost
                        Planning</button>
                      </div>
                    </ng-template>
                  </mat-step>
                  <mat-step label="Cost Planning">
                    <ng-template matStepContent>
                      <h3>Kaizen Num : K{{ KaizenCombined.kaizenNumber}}</h3>

                      <div class="form-group row">
                        <label for="kaizenDescription" class="col-sm-6 col-form-label"><b>Estimated Implementation Date : </b></label>
                        <div class="col-sm-2">
                          <label class=" col-form-label"><b>{{tableStartDate | date : 'MMMM-yyyy'}}</b></label>
                        </div>
                      </div>
                      <app-multiaccount [kaizenID]="kaizenId" [implementationYear]="impYear" [implementationMonth]="impMonth"></app-multiaccount>
                      <div>
                        <br><b> Current Status : </b>{{KaizenCombined.kaizenState }}<br>
                      </div>
                      @if (KaizenCombined.kaizenState.toString()=='Complete') {
                        <div> <b> Completion Date: </b>{{completionMonth}}/{{completionDay}}/{{completionYear}}</div>
                      }
                      @if (KaizenCombined.kaizenState.toString()=='Pending Revision') {
                        <div><br><b> Reason for Requested Revision :
                        </b>{{KaizenCombined.cmdReviewerComments }}</div>
                      }
                      <br>
                        <div class="buttonrow">
                          <button mat-flat-button matStepperPrevious mat-sroked-button type="button"
                          color="primary">Back</button>
                        </div>
                      </ng-template>
                    </mat-step>
                  </mat-stepper>